import React from "react";

const CouncilBanner = ({ data }) => {
  return (
    <div className="council-banner">
      <div className="council-banner-img">
        {data?.users[0]?.council_profile?.council_cover_photo && (
          <img
            src={data?.users[0]?.council_profile?.council_cover_photo}
            alt="council banner"
          />
        )}
      </div>
    </div>
  );
};

export default CouncilBanner;
